import { Api, HttpClient, MunicipalEntitiesApi } from '../../../api'
import {
  Context,
  PaginatedResult,
  Id,
  isAppError,
  AppErrorCode,
  throwNotImplemented,
  mapDtoToEntity,
} from '../../../common'
import {
  AddMunicipalEntityOpts,
  MunicipalEntitiesService,
  MunicipalEntity,
  MunicipalEntityFindOptions,
  UpdateMunicipalEntityOpts,
} from './municipalEntities'

function mapDtoToME(dto: Api.MunicipalEntity): MunicipalEntity {
  return mapDtoToEntity(dto)
}

export class RemoteMunicipalEntitiesService implements MunicipalEntitiesService {
  private api: MunicipalEntitiesApi

  constructor(httpClient: HttpClient) {
    this.api = new MunicipalEntitiesApi(httpClient, undefined, '')
  }

  async findAll(
    ctx: Context,
    opts?: MunicipalEntityFindOptions | undefined,
  ): Promise<PaginatedResult<MunicipalEntity>> {
    const result = await this.api.municipalEntityGetList(ctx, {
      search: opts?.filter?.search,
      ids: opts?.filter?.ids,
      direction: opts?.order?.direction,
      orderBy: opts?.order?.field,
      aFrom: opts?.paging?.from,
      count: opts?.paging?.count,
      index: opts?.filter?.index,
    })
    return {
      ...result.body,
      items: result.body.items.map(mapDtoToME),
    }
  }

  async findById(ctx: Context, id: Id): Promise<MunicipalEntity | undefined> {
    try {
      const result = await this.api.municipalEntityGetById(ctx, id)
      return mapDtoToME(result.body.object)
    } catch (e) {
      if (isAppError(e) && e.code === AppErrorCode.OBJECT_NOT_FOUND) return
      throw e
    }
  }

  async findByIndex(ctx: Context, index: number): Promise<MunicipalEntity | undefined> {
    const result = await this.findAll(ctx, { filter: { index }, paging: { count: 1 } })
    return result.items.length > 0 ? result.items[0] : undefined
  }

  async findByIdNonDeleted(ctx: Context, id: Id): Promise<MunicipalEntity | undefined> {
    const result = await this.findAll(ctx, { filter: { ids: [id] }, paging: { count: 1 } })
    return result.items.length > 0 ? result.items[0] : undefined
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  add(ctx: Context, opts: AddMunicipalEntityOpts): Promise<Id> {
    throwNotImplemented('<dd8bb271>')
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  update(ctx: Context, id: Id, opts: UpdateMunicipalEntityOpts): Promise<void> {
    throwNotImplemented('<5067d79e>')
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  delete(ctx: Context, id: Id): Promise<void> {
    throwNotImplemented('<aea0dee4>')
  }
}
